<template>
    <div class="card mb-25 border-0 bg-white add-user-card">
        <div class="card-header">
            <h3 class="text-black fw-semibold">Modification de la commande fournisseur {{ refCom }}</h3>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form @submit="modifierCommande" :validation-schema="commandeSchema">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-4 mb-2">
                                <div class="form-group">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Date Com Four. <span class="text-danger">*</span>
                                    </label>
                                    <Field name="dateOperation" v-model="dateOperation" type="datetime-local"
                                        :max="currentDateTime" class="form-control shadow-none fs-md-15 text-black"
                                        placeholder="Date oper." />
                                    <ErrorMessage name="dateOperation" class="text-danger" />
                                </div>
                            </div>

                            <div class="col-md-4 mb-2">
                                <div class="form-group">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Fournisseur <span class="text-danger">*</span>
                                    </label>
                                    <Multiselect :options="fournisseurOptions" :searchable="true" track-by="value"
                                        label="label" v-model="fournisseur" placeholder="Sélectionner le fournisseur"
                                        @update:model-value="fournisseurError = ''" />
                                    <div class="text-danger mt-1" v-if="fournisseurError">{{ fournisseurError }}</div>
                                </div>
                            </div>

                            <div class="col-md-4 mb-2">
                                <div class="form-group">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Poids total
                                    </label>
                                    <Field name="poidsTotal" type="number"
                                        class="form-control shadow-none fs-md-15 text-black"
                                        placeholder="Poids total calculé" v-model="poidsTotal" readonly />
                                </div>
                            </div>

                            <div class="col-md-4 mb-2">
                                <div class="form-group">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Nom du conducteur
                                    </label>
                                    <Field name="nomConducteur" v-model="nomConducteur" type="text"
                                        class="form-control shadow-none fs-md-15 text-black"
                                        placeholder="Nom du conducteur" />
                                    <ErrorMessage name="nomConducteur" class="text-danger" />
                                </div>
                            </div>

                            <div class="col-md-4 mb-2">
                                <div class="form-group">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        Téléphone du conducteur
                                    </label>
                                    <Field name="telephoneConducteur" v-model="telephoneConducteur" v-slot="{ field }">
                                        <vue-tel-input
                                            placeholder="Entrer le numéro de téléphone"
                                            v-model="field.value"
                                            v-bind="field"
                                            defaultCountry="BJ"
                                            mode="international"
                                            @validate="validate"
                                            class="shadow-none fs-md-15 text-black py-2">
                                        </vue-tel-input>
                                    </Field>
                                    <div v-if="telephoneConducteur && !validPhone" class="text-danger">
                                        Veuillez entrer un numéro correct
                                    </div>
                                    <ErrorMessage name="telephoneConducteur" class="text-danger" />
                                </div>
                            </div>

                            <div class="col-md-4 mb-2">
                                <div class="form-group">
                                    <label class="d-block text-black fw-semibold mb-10">
                                        N° d'immatriculation du véhicule
                                    </label>
                                    <Field name="immatriculationVehicule" v-model="immatriculationVehicule"
                                        type="text" class="form-control shadow-none fs-md-15 text-black"
                                        placeholder="Immatriculation du véhicule" />
                                    <ErrorMessage name="immatriculationVehicule" class="text-danger" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 m-10">
                        <div class="row">
                            <div class="border border-primary mb-10">
                                <div
                                    class="row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary">
                                    <div class="col-md-7">
                                        <h4 class="fs-4 text-white">Les produits</h4>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="d-flex float-end">
                                            <button class="btn btn-success" type="button" :disabled="isDisable"
                                                :class="{ 'cursor-not-allowed': isDisable }" @click="addRowProduit()">
                                                <i class="fa fa-plus-circle position-relative me-1 fs-12"></i>
                                                Ajouter un produit
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="row gx-2 mt-2 fw-semibold">
                                    <div class="col-md-5">Produit <span class="text-danger">*</span></div>
                                    <div class="col-md-2">Quantité <span class="text-danger">*</span></div>
                                    <div class="col-md-3">Description</div>
                                    <div class="col">Poids(KG)</div>
                                    <div class="col-auto"></div>
                                </div>
                                <hr class="mt-1" />

                                <div class="row gx-2" v-for="(produit, produitIndex) in produits" :key="produitIndex">
                                    <div class="col-md-5 mb-2">
                                        <Multiselect v-model="produit.produit"
                                            :options="listeProduitDisponible(produitIndex)" :searchable="true"
                                            placeholder="Sélectionner un produit"
                                            @select="selectProd(produit.produit, produit)" :class="validateRowProduit(produit.produit)
                                                ? 'fs-md-15 text-black is-invalid'
                                                : 'fs-md-15 text-black'" />
                                        <div class="text-danger" v-if="validateRowProduit(produit.produit)">
                                            Le produit est obligatoire.
                                        </div>
                                    </div>

                                    <div class="col-md-2 mb-2">
                                        <div class="input-group">
                                            <input type="number" v-model="produit.qteBon" :class="validateRowProduit(produit.qteBon)
                                                ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                                : 'form-control shadow-none fs-md-15 text-black'"
                                                placeholder="Quantité" />
                                            <span class="input-group-text">
                                                {{ produit.uniteMesure != null
                                                    ? produit.uniteMesure.replace("[", "").replace("]", "")
                                                    : 'UM' }}
                                            </span>
                                        </div>
                                        <div class="text-danger" v-if="validateRowProduit(produit.qteBon)">
                                            La quantité est obligatoire.
                                        </div>
                                    </div>

                                    <div class="col-md-3 mb-2">
                                        <textarea v-model="produit.description" rows="1"
                                            class="form-control shadow-none fs-md-15 text-black description-textarea"
                                            placeholder="Description"></textarea>
                                    </div>

                                    <div class="col mb-2">
                                        <input type="number" min="0" step="any" v-model="produit.poids" :class="poidsInvalide(produit.poids)
                                            ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                            : 'form-control shadow-none fs-md-15 text-black'"
                                            placeholder="Poids" />
                                        <div class="text-danger" v-if="poidsInvalide(produit.poids)">
                                            Le poids doit être positif.
                                        </div>
                                    </div>

                                    <div class="col-auto mb-2">
                                        <button class="btn btn-danger transition border-0 pb-2 px-2" type="button"
                                            @click="removeRowProduit(produitIndex)">
                                            <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <div class="d-flex align-items-center">
                            <button ref="submitButton" class="btn btn-success me-3" type="submit" :disabled="isDisable">
                                Enregistrer les modifications
                            </button>
                            <router-link :to="{ name: 'ViewCommandeFournisseurPage', params: { id: commandeId } }"
                                class="btn btn-danger">
                                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler
                            </router-link>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import 'vue3-tel-input/dist/vue3-tel-input.css'
import { VueTelInput } from 'vue3-tel-input'
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter, useRoute } from 'vue-router';
import Multiselect from '@vueform/multiselect';

const STATUT_EN_ATTENTE = "en attente de validation";

interface LigneProduit {
    produit: string;
    qteBon: number;
    description: string;
    poids: number | string;
    nomProd: string;
    uniteMesure: string | null;
}

export default defineComponent({
    name: "EditCommandeFournisseur",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect,
        VueTelInput
    },

    setup: () => {
        const router = useRouter();
        const route = useRoute();
        const commandeId = route.params.id as string;

        const commandeSchema = Yup.object().shape({
            dateOperation: Yup.string().required('La date de l\'opération est obligatoire'),
            nomConducteur: Yup.string().notRequired(),
            telephoneConducteur: Yup.string().notRequired(),
            immatriculationVehicule: Yup.string().notRequired(),
            poidsTotal: Yup.number().notRequired(),
        });

        const refCom = ref('');
        const dateOperation = ref(formatDateTimeLocal(new Date()));
        const currentDateTime = ref(formatDateTimeLocal(new Date()));
        const fournisseur = ref<number | null>(null);
        const fournisseurOptions = ref([]);
        const produitOptions = ref([]);
        const poidsTotal = ref(0);
        const nomConducteur = ref('');

        const telephoneConducteur = ref('');
        const validPhone = ref(true);
        const validate = (phoneObject: any) => {
            validPhone.value = !!phoneObject?.valid;
        };

        const immatriculationVehicule = ref('');
        const isDisable = ref(true);
        const submitButton = ref<HTMLButtonElement | null>(null);
        const fournisseurError = ref('');

        const newLigne = (): LigneProduit => ({
            produit: '',
            qteBon: 0,
            description: '',
            poids: '',
            nomProd: '',
            uniteMesure: null,
        });

        const produits = reactive<LigneProduit[]>([newLigne()]);

        const totals = () => {
            const total = produits.reduce((acc, p) => acc + (parseFloat(p.poids as any) || 0), 0);
            poidsTotal.value = Math.round(total * 1000) / 1000;
        };

        const addRowProduit = () => {
            produits.push(newLigne());
        };

        const removeRowProduit = (index: number) => {
            if (produits.length > 1) produits.splice(index, 1);
            totals();
        };

        const validateRowProduit = (e: any) => {
            return e === '' || e === 0 || e === '0' || e == null || e < 0;
        };

        // Le poids est facultatif : invalide seulement s'il est renseigné et négatif
        const poidsInvalide = (poids: any): boolean => {
            if (poids === '' || poids === null || poids === undefined) {
                return false;
            }
            return isNaN(Number(poids)) || Number(poids) < 0;
        };

        const produit_value = (val: string) => {
            if (!val) return null;
            return val.split('|')[0];
        };

        const listeProduitDisponible = (currentIndex: number) => {
            const selectedIds = produits
                .filter((_, index) => index !== currentIndex && produit_value(_.produit))
                .map(p => produit_value(p.produit));

            return produitOptions.value.filter((option: any) => {
                const productId = option.value.split('|')[0];
                return !selectedIds.includes(productId);
            });
        };

        const selectProd = (selectedProduit: string, produit: any) => {
            const parts = selectedProduit.split('|');
            produit.nomProd = parts[1] + ' - ' + parts[2];
            produit.uniteMesure = parts[3];
            produit.qteBon = produit.qteBon || 1;
        };

        watch(produits, (newValue) => {
            isDisable.value = newValue.some(p => p.qteBon < 1 || p.produit === '' || poidsInvalide(p.poids));
            totals();
        }, { deep: true });

        const fetchFournisseur = async () => {
            try {
                const response = await ApiService.get("all/fournisseurs");
                const fournisseurData = response.data.data.data;
                fournisseurOptions.value = fournisseurData.map((f: any) => {
                    if (f.statut === 2 || f.statut === "2") {
                        return { value: f.id, label: `${f.sigle} - ${f.denomination}` };
                    }
                    return {
                        value: f.id,
                        label: f.nomFournisseur && f.prenomFournisseur
                            ? `${f.nomFournisseur} ${f.prenomFournisseur}`
                            : `${f.denomination || f.nomFournisseur}`
                    };
                });
            } catch (err) {
                //
            }
        };

        const fetchProduits = async () => {
            try {
                const response = await ApiService.get("/all/produitconditionnements");
                const produitsData = response.data.data;

                if (!produitsData || !Array.isArray(produitsData)) {
                    produitOptions.value = [];
                    return;
                }

                produitOptions.value = produitsData.map((item: any) => {
                    const produit = item.produit;
                    const conditionnement = item.conditionnement;
                    if (!produit || !conditionnement) return null;

                    return {
                        value: `${item.id}|${produit.codeProduit}|${produit.nomProd}|[${conditionnement.libelle}]`,
                        label: `${produit.nomProd} [${conditionnement.libelle}] - ${produit.codeProduit}`,
                    };
                }).filter((opt: any) => opt !== null);
            } catch (err) {
                produitOptions.value = [];
            }
        };

        // Remplit le formulaire avec la commande existante
        const fetchCommande = async () => {
            try {
                const response = await ApiService.get(`/commandesFournisseurs/${commandeId}`);
                const commande = response.data.data;

                if (commande.statut !== STATUT_EN_ATTENTE) {
                    error("Seule une commande en attente de validation peut être modifiée.");
                    router.push({ name: "ViewCommandeFournisseurPage", params: { id: commandeId } });
                    return;
                }

                refCom.value = commande.refCom;
                dateOperation.value = formatDateTimeLocal(new Date(commande.dateComFrs));
                fournisseur.value = commande.fournisseur ? commande.fournisseur.id : null;
                nomConducteur.value = commande.nomConducteur || '';
                telephoneConducteur.value = commande.telephoneConducteur || '';
                immatriculationVehicule.value = commande.immatriculationVehicule || '';

                produits.splice(0, produits.length);

                const lignes = commande.commandefourniseurprocondis || [];
                if (lignes.length > 0) {
                    for (const ligne of lignes) {
                        const option: any = produitOptions.value.find(
                            (o: any) => o.value.split('|')[0] === String(ligne.refProd)
                        );

                        const ligneForm = newLigne();
                        ligneForm.produit = option ? option.value : '';
                        ligneForm.nomProd = ligne.nomProd;
                        ligneForm.qteBon = Number(ligne.qteComfrs) || 0;
                        ligneForm.description = ligne.description || '';
                        ligneForm.poids = ligne.poids !== null && ligne.poids !== undefined ? ligne.poids : '';
                        ligneForm.uniteMesure = option ? option.value.split('|')[3] : null;
                        produits.push(ligneForm);
                    }
                } else {
                    produits.push(newLigne());
                }

                totals();
                isDisable.value = produits.some(p => p.qteBon < 1 || p.produit === '' || poidsInvalide(p.poids));
            } catch (err: any) {
                error(err.response?.data?.message || "Erreur lors du chargement de la commande");
            }
        };

        if (!validPhone.value) {
            error("Le numéro de téléphone du conducteur est invalide");
            return;
        }

        const modifierCommande = async () => {
            if (!fournisseur.value) {
                fournisseurError.value = 'Le fournisseur est obligatoire';
                return;
            }
            fournisseurError.value = '';

            if (submitButton.value) submitButton.value.disabled = true;

            const donnees = {
                dateOperation: dateOperation.value,
                fournisseur: fournisseur.value,
                nomConducteur: nomConducteur.value.trim(),
                telephoneConducteur: telephoneConducteur.value.trim(),
                immatriculationVehicule: immatriculationVehicule.value.trim(),
                produitsCommande: produits.map((p) => ({
                    produit: p.produit.split("|")[0],
                    qteBon: p.qteBon,
                    description: p.description,
                    poids: p.poids === '' ? null : p.poids,
                    uniteMesure: p.uniteMesure,
                    nomProd: p.nomProd,
                })),
            };

            try {
                await ApiService.put(`/commandesFournisseurs/${commandeId}`, donnees);
                success("La commande fournisseur a été modifiée avec succès");
                router.push({ name: "ViewCommandeFournisseurPage", params: { id: commandeId } });
            } catch (err: any) {
                if (submitButton.value) submitButton.value.disabled = false;
                error(err.response?.data?.message || "Erreur lors de la modification de la commande fournisseur");
            }
        };

        function formatDateTimeLocal(date: Date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        }

        onMounted(async () => {
            // Les options doivent être chargées avant de remplir les lignes
            await Promise.all([fetchFournisseur(), fetchProduits()]);
            await fetchCommande();
            currentDateTime.value = formatDateTimeLocal(new Date());
        });

        return {
            commandeSchema,
            commandeId,
            refCom,
            dateOperation,
            currentDateTime,
            fournisseur,
            fournisseurOptions,
            produitOptions,
            poidsTotal,
            nomConducteur,
            telephoneConducteur,
            immatriculationVehicule,
            isDisable,
            submitButton,
            produits,
            fournisseurError,
            modifierCommande,
            addRowProduit,
            removeRowProduit,
            validateRowProduit,
            poidsInvalide,
            listeProduitDisponible,
            selectProd,
        };
    },
});
</script>

<style scoped>
.cursor-not-allowed {
    cursor: not-allowed;
}

.description-textarea {
    height: calc(1.5em + 0.75rem + 2px); /* même hauteur qu'un input Bootstrap */
    min-height: calc(1.5em + 0.75rem + 2px);
    max-width: 100%;
    resize: both;
    overflow: auto;
}
</style>